import { ITinyCompanies } from '@core/interfaces/companies-items';
import { IEntity, ITinyEntity } from '@core/interfaces/entity-items';
import { ILocation, IState } from '@core/interfaces/commons';
import { ICurrencies } from '@core/interfaces/currencies-items';
import { IFiscalPositions } from '@core/interfaces/fiscal-positions-items';
import { IPaymentTerms } from '@core/interfaces/payment-terms-items';
import { IPaymentMethods } from '@core/interfaces/payment-methods-items';
import { IBinders } from '@core/interfaces/binders-items';
import { IInvoiceSendItems } from '@core/interfaces/invoice-send-items-items';
import { IRefundSageExports } from '@core/interfaces/refund-sage-exports-items';
import { IProducts } from '@core/interfaces/products-items';
import { ITaxes } from '@core/interfaces/taxes-items';

export enum InvoiceTypeEnum {
  CustomerInvoice = 'customer-invoice',
  CustomerRefund = 'customer-refund',
}

type TInvoiceType = InvoiceTypeEnum.CustomerInvoice | InvoiceTypeEnum.CustomerRefund;

export interface ITinyInvoice {
  id: number;
  code: string;
  number: string;
  created_by: string;
  customer_ref: string;
  state: IState;
  type: TInvoiceType;
}

export interface IInvoice extends ITinyInvoice {
  binder?: IBinders;
  company: ITinyCompanies;
  created_at: string;
  currency: ICurrencies;
  date: string;
  description_external?: string;
  description_internal: string;
  due_date: string;
  entity: IEntity;
  exchange_rate: string;
  fiscal_position?: IFiscalPositions;
  has_refunds: boolean;
  invoice_send_item?: IInvoiceSendItems;
  language_affinity: string;
  location: ILocation;
  number: string;
  parents: ITinyInvoice[];
  parent_ids: number[];
  payment_amount: string;
  payment_delay: number;
  payment_method: IPaymentMethods;
  payment_status: number;
  payment_term: IPaymentTerms;
  refund_sage_export?: IRefundSageExports;
  total: string;
  total_taxes: string;
  total_untaxed: string;
}

export interface IRefundWithLineIds extends Partial<IInvoice> {
  item_ids: number[];
}

export interface IInvoiceGroup {
  id: number;
  invoice: ITinyInvoice;
}

export interface IInvoiceItem {
  id: number;
  code: string;
  name: string;
  description: string;
  customer_ref: string;
  group: IInvoiceGroup;
  product: IProducts;
  taxes: ITaxes[];
  quantity: number;
  unit_price: number;
  discount: number;
  subtotal_untaxed: number;
  subtotal_taxes: number;
  subtotal: number;
}
